import styled from 'styled-components';

interface Props {
  readonly wasWatched?: boolean;
}

const VideoThumbStyles = styled.div<Props>`
  border-radius: 12px;
  background: ${({ wasWatched }: Props): string =>
    wasWatched ? 'rgba(255, 255, 255, 0.32)' : 'rgba(77, 70, 223, 0.4)'};
  width: 173px;
  height: 120px;
  position: absolute;
`;

export default VideoThumbStyles;
